/**
 * Registers the service worker that makes the application installable.
 *
 * **Production only.** In development Vite serves unbundled modules and replaces
 * code as it changes; a service worker holding on to the shell would return
 * stale files on every reload and need unregistering by hand before a change
 * appeared.
 *
 * Registration waits for `load`: the first paint is what somebody is waiting
 * for, and caching the shell can happen once it is on screen.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    // A failed registration — private browsing, an insecure origin — must break
    // nothing: the service worker adds installation and an offline shell, and
    // the application works without either.
    void navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
